/**Import angular core packages */
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store, Action } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  debounceTime
} from 'rxjs/operators';
/**Custom imports */
import { Utilities } from '../../../../../shared/outer-services/utilities.service';
import { StorageService } from '../../../../../shared/outer-services/storage.service';
import { OccApiCallClass } from '../../occ-constants/model';
import { OccApiCallService } from '../../occ-services/occ-apicalls.service';
import { OccDispatchService } from '../../occ-services/occ-dispatch.service';
import { OccSnackBar } from '../../occ-modal/occ-modal-component';
import { Occ_Settings_Tab_Text_State, Occ_Index_Reducer_Text_State, Occ_Buttons_Reducer_Text_State, Occ_EmpOutlook_Wages_State } from '../../occ-state-management/occ-state/occ-state';
import { OccCommonMethodsService } from '../../occ-services/occ-common-methods.service';
import { EventDispatchService } from '../../../../../shared/outer-services/event-dispatch.service';
import { FrameworkConfigState } from '../../../../../state-management/state/main-state';

@Component({
  selector: 'occ-emerg-header',
  templateUrl: './emergCareers-layout.html',
})

export class OccEmergHeaderComponent implements OnInit, OnDestroy {
  accountId; // Declare for storing the value of accountid
  occName; // Declare for storing the occName value
  occEmergingStore; // Declare for assigning the value of OCCPageStatestore
  occTextStore; // Declare for assinging the value of store
  settingsText; // Declare for assigning the subscribing value of Occ_Settings_Tab_Text
  clusterIcon = ''; // Declare the params value of clusterIcon
  clusterColor = ''; //Declare the params value of clustercolor
  value = 'About this Career'; //Declare for storing the values of dropdownmenus list
  occID = ''; //Declare for storing the occid value
  showColorUp = -1; //Declare for storing the thumbs value
  langVal; //Declare for storing of sessionstorageget value of langset
  activeVal = 0; //Declare for dropdown menu lists value
  filter: any; /** boolean value toggle in mobile  */
  hideVal = 0;
  backAssessmentValue = false;
  emergingJsonValue = [];
  subscription = new Subscription;
  langChange = false;
  occclusinx = '';
  occIndexReducerSub = new Subscription;
  Occ_Buttons_Reducer_Text = new Subscription;
  Occ_Settings_Tab_Text = new Subscription;
  outereventsubscription = new Subscription;
  public snackbar = new OccSnackBar();
  frameworkObj: any;
  logo: any;
  @ViewChild('videoplayer') videoplayer: ElementRef;
  @ViewChild('occEmergingFocus', { static: true }) occEmergingFocusElement: ElementRef;
  restrictedAccountConstant; /**Variable used to store restrictedaccounttype  */
  accountTypeJwt; /**Variable used to store accounttype from JWT */
  restrictedAccountType: boolean;
  fromRoute: string;

  hasCareer: boolean = false; /** To check whether the component is only for career or not */
  showMilCareer: boolean = false; /** To show mil careers in career detail */
  showPOS: boolean = false; /** To show POS in career detail */
  careerHeaderTabId: number = -1;
  occInfoTabs: any[] = [];

  constructor(
    private router: Router,
    private occstore: Store<Occ_Buttons_Reducer_Text_State>,
    private activatedRoute: ActivatedRoute,
    private utils: Utilities,
    private storageService: StorageService,
    private occSetstore: Store<Occ_Settings_Tab_Text_State>,
    private dispatchStore: Store<Action>,
    private OCCPageStateStore: Store<Occ_EmpOutlook_Wages_State>,
    private occIndexstore: Store<Occ_Index_Reducer_Text_State>,
    private apiJson: OccApiCallClass,
    private occCommonService: OccCommonMethodsService,
    private occApiCall: OccApiCallService,
    private occDispatch: OccDispatchService,
    private eventService: EventDispatchService, private Frameworkstore: Store<FrameworkConfigState>,
    @Inject('RESTRICTED_ACCOUNT_TYPE') public restrictedAccount: string,
    @Inject('CAREER_IMAGE_URL') public CareersImages: string
    ) {
      this.dispatchStore.dispatch({ type: 'RESET_OCC_PAGE' });
      this.accountTypeJwt = this.utils.getDecodedAccessToken().accountType;
      this.restrictedAccountConstant = restrictedAccount;
   if (this.accountTypeJwt !== this.restrictedAccountConstant) {
       this.restrictedAccountType = true;
   } else {
       this.restrictedAccountType = false;
   }
   this.storageService.sessionStorageSet('activeSortId', 'fileOcc');
    document.title = 'Careers';
    this.subscription = this.Frameworkstore.select('config').subscribe((res) => {
      if (res.config) {
        this.frameworkObj = res.config;
      }

    });
    const ref = this;
    function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = function () {
        let canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        let dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        try {
          dataURL = canvas.toDataURL(outputFormat);
          callback(dataURL);
          canvas = null;
        } catch (e) {
        } finally {
          dataURL =
            'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
          callback(dataURL);
          canvas = null;
        }
      };
      img.src = url;
    }
    convertImgToDataURLviaCanvas(ref.frameworkObj.Result.user.logo, function (base64Img) {
      ref.logo = base64Img;
    }, 'base64');
    this.utils.showLoading();
    if (!this.storageService.sessionStorageGet('OccIndexReducerText') || !this.storageService.sessionStorageGet('Reducer_OccText')) {
      this.occCommonService.OccIndexDispatch();
    }
    this.langVal = this.storageService.sessionStorageGet('langset');
    /** Below code block listens broadcasted event and
 * calls respective functionality */
    this.subscription = occDispatch.listen().subscribe((occDisp) => {
      /** After event listen it will check whether user want functionality of
       * languagechanged event and relatedemergingdispatch event*/
      if (occDisp.type === 'relatedEmergingDispatch') {
        this.activeVal = 0;
        this.ngOnInit();

      } else if (occDisp.type === 'languageChanged') {
        this.langVal = this.storageService.sessionStorageGet('langset');
        const Arr = this.router.url.split('?');
        const routArr = Arr[0].split('/');
        this.hideVal = 0;
        this.langChange = true;
        if (routArr.indexOf('occEmergCareer') !== -1) {
          this.ngOnInit();
        }
      }
    });

    /**get the data from reducer related effect name**/
    let value = true;
    this.occIndexReducerSub = this.occIndexstore.select('Occ_Index_Reducer_Text').pipe(debounceTime(100)).subscribe((resOccIndex) => {
      if (this.storageService.sessionStorageGet('parentCnt') === 'true') {
        this.savedCareerNames();
      }
      if (this.fromRoute === 'progs' && value === true && resOccIndex && resOccIndex.Occ_Index_Reducer_Text.occList) {
        value = false;
        this.fromProgs();
        this.ngOnInit();
      }
      if (this.fromRoute === 'mils' && value === true && resOccIndex && resOccIndex.Occ_Index_Reducer_Text.occList) {
        value = false;
        this.fromMils();
        this.ngOnInit();
      }
    });
    this.occEmergingStore = this.OCCPageStateStore.select('Occ_EmpOutlook_Wages');
    this.Occ_Buttons_Reducer_Text = this.occstore.select('Occ_Buttons_Reducer_Text').subscribe((resOccButtons) => {
      // if (this.langChange  ===  true) {
      this.occTextStore = resOccButtons;
      // }
    });

    this.Occ_Settings_Tab_Text = this.occSetstore.select('Occ_Settings_Tab_Text').subscribe((resOccSettings) => {
      if (resOccSettings && resOccSettings.Occ_Settings_Tab_Text && resOccSettings.Occ_Settings_Tab_Text.topSections) {
        this.settingsText = resOccSettings;
        this.occInfoTabs = this.settingsText.Occ_Settings_Tab_Text?.tabs;

        this.hideLoadingSymbol();

        if (this.storageService.sessionStorageGet('loginFrameworkConfiguration')) {
          const frameWork = JSON.parse(this.storageService.sessionStorageGet('loginFrameworkConfiguration'));
          const tabs = frameWork?.config?.Result?.headerFooter?.tabs;
          const allTabItems = frameWork?.config?.Result?.tabItems;
          console.log('allTabItems:', allTabItems);
          if (allTabItems && allTabItems.length > 0) {
            /**check if career component exists */
            for (const items of allTabItems) {
              if (items.compList.some(item => item.compId === 'fileOcc')) {
                this.hasCareer = true;
                this.careerHeaderTabId = items.tabId;
              }
              if (items.compList.some(item => item.compId === 'fileProg')) {
                this.showPOS = true;
              }
              if (items.compList.some(item => item.compId === 'fileMil')) {
                this.showMilCareer = true;
              }
            }

          }

        }

        /**Check database setting if using tabId is a good way
         * to eleimate unwanted tabs.
         */
        console.log('isCareersCompOnly:', this.hasCareer, this.careerHeaderTabId, this.showMilCareer, this.showPOS);
        if (this.hasCareer && !this.showPOS && !this.showMilCareer) {
          if (this.occInfoTabs && this.occInfoTabs.length > 0) {
            this.occInfoTabs = this.occInfoTabs.filter(tab => tab.tabId !== 5);
          }
        }
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      this.occID = params['occid'];
      this.occclusinx = params['inx'];
      this.occName = params['occname'];
      this.fromRoute = params['fromRoute'];
      this.ngOnInit();
      if (this.fromRoute === 'progs') {
        this.fromProgs();
      } else if (this.fromRoute === 'mils') {
        this.fromMils();
      } else {
        this.clusterIcon = params['clusIcon'];
        this.clusterColor = params['clusColor'];
      }
    });
    this.outereventsubscription = this.eventService.listenStaticContent().subscribe((e) => {
      if (this.occEmergingFocusElement) {
        this.occEmergingFocusElement.nativeElement.setAttribute('tabindex', '0');
        this.occEmergingFocusElement.nativeElement.focus();
      }
    });


  }
  fromProgs() {
    let clusterId;
    const val = JSON.parse(this.storageService.sessionStorageGet('OccIndexReducerText'));
    if (val && val.Occ_Index_Reducer_Text.occList) {
      val.Occ_Index_Reducer_Text.occList.forEach((obj: any) => {
        if (obj.occID === parseInt(this.occID)) {
          clusterId = obj.clusterID;
        }

      });
      const clsVal = this.occCommonService.clustDetails(clusterId);

      this.clusterIcon = clsVal.clusterIconValue;
      this.clusterColor = clsVal.clusterBgColor;
    }
  }
  fromMils() {
    let clusterId;
    const val = JSON.parse(this.storageService.sessionStorageGet('OccIndexReducerText'));
    if (val && val.Occ_Index_Reducer_Text.occList) {
      val.Occ_Index_Reducer_Text.occList.forEach((obj: any) => {
        if (obj.occID === parseInt(this.occID)) {
          clusterId = obj.clusterID;
        }
      });
      const clsVal = this.occCommonService.clustDetails(clusterId);

      this.clusterIcon = clsVal.clusterIconValue;
      this.clusterColor = clsVal.clusterBgColor;
    }
  }

  /**hideLoadingSymbol method is used for the hide the loading symbol */
  hideLoadingSymbol() {
    if (this.occName && this.settingsText) {
      if (this.settingsText.Occ_Settings_Tab_Text.topSections) {
        const ref = this;
        setTimeout(function () {
          ref.utils.hideLoading();
        }, 500);
      }
    }
  }

  /** ngOnInit method is called at the time of initialization of the component */
  ngOnInit() {
    this.savedCareerNames();
    /**this condition is for backtoassessment button when the user come from assessments or from careers */
    if (this.storageService.sessionStorageGet('inTab')) {
      if (this.storageService.sessionStorageGet('inTab') === 'Assess' || this.storageService.sessionStorageGet('inTab') === 'cciAssess'
        || this.storageService.sessionStorageGet('inTab') === 'osAssess') {
        this.backAssessmentValue = true;
      } else {
        this.backAssessmentValue = false;
      }
    }
    this.storageService.sessionStorageSet('occIDval', this.occID);
    this.emergingJsonValue['clusIcon'] = this.clusterIcon;
    this.emergingJsonValue['clusColor'] = this.clusterColor;
    this.accountId = 'accountID';
    this.dispatchStore.dispatch({
      type: 'GET_SECTIONS_TEXT', payload: {
        methodVal: 'GET', module_Name: 'occ/v2/',
        path_params: ['emerging', this.occID, this.accountId],
        query_params: { 'sections': 'all', 'lang': this.langVal },
        body_Params: {}, endUrlVal: 'pages', text: ''
      }
    });

    this.getText();
    this.getRating();
  }
  savedCareerNames() {
    const val = JSON.parse(this.storageService.sessionStorageGet('OccIndexReducerText'));
    let value = true;
    if (val && val.Occ_Index_Reducer_Text.occList) {
      val.Occ_Index_Reducer_Text.occList.forEach((list) => {
        if ((list.occID === parseInt(this.occID)) && value === true) {
          this.occName = (list.title);
          value = false;
        }
      });
    }
  }
  videostop() {
    this.videoplayer.nativeElement.load();
    this.videoplayer.nativeElement.pause();
  }
  /**ngOnDestroy method is called when user destroying the component */
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.occIndexReducerSub.unsubscribe();
    this.Occ_Buttons_Reducer_Text.unsubscribe();
    this.Occ_Settings_Tab_Text.unsubscribe();
    this.outereventsubscription.unsubscribe();
    this.storageService.removeSessionIndexes(true);
  }

  /**dropDownVal method is for the dropDown menu dispalyed in mobileview */
  dropDownVal(name, val) {

    this.value = name;
    this.activeVal = val;
    const evnt = document.createEvent('CustomEvent');
    evnt.initEvent(name, true, true);
    this.occDispatch.dispatch(evnt);
  }

  /**getUnFill method is for filling the thumbs icons */
  getUnFill(thumbVal) {
    this.utils.showLoading();
    if (thumbVal === 'up' && (this.showColorUp !== 1)) {
      this.showColorUp = 1;
    } else {
      this.showColorUp = -1;
    }
    this.resultPost();
  }

  /**savePost method is for saving the result of favorites*/
  savePost() {

    this.utils.showLoading();
    this.apiJson.method = 'POST';
    this.apiJson.sessionID = this.storageService.sessionStorageGet('auth_key');
    this.apiJson.moduleName = 'occ/v2/';
    const saveResult = {
      input_data: [
        {
          'param_type': 'path',
          'params': [this.accountId, 'favorites', this.occID]
        },
        {
          'param_type': 'query',
          'params': { 'lang': this.langVal }
        }

      ]
    };
    const user = JSON.stringify(saveResult);

    this.apiJson.endUrl = 'users';
    this.apiJson.data = user;
    this.occApiCall.callApi([this.apiJson]).subscribe((res) => {

      if (res.Result + '' === 'true') {
        this.utils.hideLoading();
        const evnt = document.createEvent('CustomEvent');
        evnt.initEvent('PlanCompStatus', true, true);
        this.eventService.dispatch(evnt);
        this.snackbar.myFunction('Successfully added to favorites.');
      }

    }, e => this.utils.handleError(`emergCareers-header-component.ts savePost: ${e.message}`));

  }

  /**getRating method is for the get the rating with ratings call */
  getRating() {
    this.apiJson.method = 'GET';
    this.apiJson.sessionID = this.storageService.sessionStorageGet('auth_key');
    this.apiJson.moduleName = 'occ/v2/';
    const getThumbsResult = {
      input_data: [
        {
          'param_type': 'path',
          'params': [this.accountId, 'ratings', this.occID]
        },
        {
          'param_type': 'query',
          'params': { 'lang': this.langVal }
        }

      ]
    };
    const user = JSON.stringify(getThumbsResult);
    this.apiJson.endUrl = 'users';
    this.apiJson.data = user;
    this.occApiCall.callApi([this.apiJson]).subscribe((res) => {
      if (res[0].Success + '' === 'true') {

        if (res[0].Result === 1) {

          this.showColorUp = 1;
        } else if (res[0].Result === 0) {

          this.showColorUp = 0;
        } else {

          this.showColorUp = -1;
        }
      }
    }, e => this.utils.handleError(`emergCareers-header-component.ts getRating: ${e.message}`));

  }

  /**getText method is for dispatching the pages call text and settings call text*/
  getText() {
    // if (this.langChange  ===  false) {
    const val = JSON.parse(this.storageService.sessionStorageGet('Reducer_OccText'));
    if (val && val.Occ_Buttons_Reducer_Text && val.Occ_Buttons_Reducer_Text.common) {
      this.occTextStore = val;
    }
    // }
    const asmtEndurl = (this.restrictedAccountType) ? 'occ/emerging' : 'occ/emerging/default';

    this.dispatchStore.dispatch({
      type: 'GET_OCC_SETTING_TABS_TEXT', payload: {
        methodVal: 'GET', module_Name: 'Settings/v1/',
        path_params: (this.restrictedAccountType) ? ['accountID'] : [],
        query_params: { 'lang': this.langVal },
        body_Params: {}, endUrlVal: asmtEndurl
      }
    });

  }

  /**resultPost method is for posting the result of ratings */
  resultPost() {
    setTimeout(function () {
      this.apiJson.method = 'POST';
      this.apiJson.sessionID = this.storageService.sessionStorageGet('auth_key');
      this.apiJson.moduleName = 'occ/v2/';
      const starResult = {
        input_data: [
          {
            'param_type': 'path',
            'params': [this.accountId, 'ratings', this.occID, this.showColorUp]
          },
          {
            'param_type': 'query',
            'params': { 'lang': this.langVal }
          }

        ]
      };
      const user = JSON.stringify(starResult);
      this.apiJson.endUrl = 'users';
      this.apiJson.data = user;
      this.occApiCall.callApi([this.apiJson]).subscribe((res) => {
        if (res.Result + '' === 'true') {
          const val = JSON.parse(this.storageService.sessionStorageGet('OccIndexReducerText'));
          val.Occ_Index_Reducer_Text.occList.forEach(res => {
            if (res.occID === parseInt(this.occID, 10)) {
              res.rating = this.showColorUp;
            }
          });
          this.storageService.sessionStorageSet('OccIndexReducerText', JSON.stringify(val));
        }
        this.utils.hideLoading();
      }, e => this.utils.handleError(`emergCareers-header-component.ts resultPost: ${e.message}`));
    }.bind(this));
  }

  /**backAssessment method is for the backtoassessment
   *  button clicking,when we come from the ip assessment  */
  backAssessment() {
    //when back assessment data was clicked navigate to respective page
    this.storageService.sessionStorageSet('fromCareers', 'yes');
    if (this.storageService.sessionStorageGet('inTab') !== 'cciAssess' && this.storageService.sessionStorageGet('inTab') !== 'osAssess') {
      this.router.navigate(['../../' + this.storageService.sessionStorageGet('prevRoute') + '/occlist'], { relativeTo: this.activatedRoute });
    } else {
      this.router.navigate(['../../' + this.storageService.sessionStorageGet('prevRoute') + '/result'], { relativeTo: this.activatedRoute });
    }
  }

  /**careerlist method is for careerlist button,after clicking it will go to the occIndex page */
  CareerList(check) {
    if (this.occclusinx === 'title') {
      this.storageService.sessionStorageSet('occShow', '1');
    } else {
      this.storageService.sessionStorageSet('occShow', '0');
    }
    this.storageService.sessionStorageSet('personalQua', 'no');
    this.router.navigate(['../occIndex'], { relativeTo: this.activatedRoute, queryParams: { chk: check, occclusinx: this.occclusinx } });
  }
  emergingPrint() {
    this.utils.showLoading();
    const evnt = document.createEvent('CustomEvent');
    evnt.initEvent('emergingEvent' + this.activeVal, true, true);
    this.occDispatch.dispatch(evnt);
  }

}

